import React from "react";

import type { InputProps } from "../answers";
import { DateField } from "../DateField";

export const DateInput: React.FC<InputProps<"date">> = ({ answer, onChange, error }) => (
    <DateField
        value={typeof answer?.value === "string" ? answer.value : undefined}
        onChange={(value) => onChange({ ...answer, value })}
        error={error}
    />
);
